import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, ref, watch} from 'vue';
import {headerHeight, isMobile, shrunkSearch} from "./headerState";
import {type zohoNavItem, isNative, navbarDefaultWidth, getZohoNavLinks, routeToDestinations, logOut} from './functions';

type Props = {
	navbarWidth?: string
}
type tabs = typeof tabsOptions[number]

export default /*#__PURE__*/_defineComponent({
  __name: 'global-header',
  props: {
    navbarWidth: { default: navbarDefaultWidth }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "0dcce437": (_ctx.navbarWidth),
  "7570dd93": (_unref(headerHeight))
}))

const props = __props;

const tabsOptions = ['destinations', 'registration', 'whoCanGo', 'about', 'answers'];
const tabsNameMap: {[key: tabs]: string} = {
	'destinations': 'Destinations',
	'registration': 'Registration',
	'whoCanGo': 'Who Can Go?',
	'about': 'About',
	'answers': 'Answers'
};

const zohoLinks = ref<zohoNavItem[]>([]);
onMounted(async () => {
	zohoLinks.value = (await getZohoNavLinks()).filter((link) => link.region === 'header');
});

const linksBySections = computed(() => {
	const sectionedLinks: {[section: string]: {[subSection: string]: zohoNavItem[]}} = {};
	zohoLinks.value.forEach((link) => {
		if(!sectionedLinks?.[link.section]) sectionedLinks[link.section] = {};
		if(link.subSection){
			if(!sectionedLinks[link.section]?.[link.subSection]){
				sectionedLinks[link.section][link.subSection] = [];
			}
			sectionedLinks[link.section][link.subSection].push(link);
		}
		if(!link.subSection){
			if(!sectionedLinks[link.section]?.empty){
				sectionedLinks[link.section].empty = [];
			}
			sectionedLinks[link.section].empty.push(link);
		}
	});

	Object.keys(sectionedLinks).forEach((section) => Object.keys(sectionedLinks[section]).forEach((subSection) => {
		sectionedLinks[section][subSection].sort((a, b) => (a?.order || 0) - (b.order || 0));
	}));

	return sectionedLinks;
});


const selected = ref<tabs | null>(null);
const searchBarExpanded = ref<boolean>(false);
const hideContent = ref<boolean>(false);

function expandSearch(){
    mobileDropdownExpanded.value = false;
	hideContent.value = true;
	setTimeout(()=>{
		searchBarExpanded.value = true;
	},150);

};

function shrinkSearch(){
	searchBarExpanded.value = false;
	hideContent.value = !hideContent.value;
	setTimeout(()=>{
	},150);
}

function closeSearch(){
	console.log("Close Search Is Being Hit");
	searchQuery.value = "";
	results.value = [];
	loading.value = false;
	shrinkSearch();
}
//const selected = ref<tabs | null>("about");

const hovering = ref<tabs | 'window' | null>(null);
const handleHover = (hover: tabs | 'window') => {
	hovering.value = hover;
	if(hover !== 'window'){
		selected.value = hover;
	}
};
const handleLeaveHover = () => {
	hovering.value = null;
	setTimeout(() => {
		if(hovering.value === null){
			selected.value = null;
		}
	}, 100);
};

const handleTabClick = (tab: tabs) =>{
	if(tab === 'destinations'){
		routeToDestinations();
	}
};

const mobileDropdownExpanded = ref(false);
const handleSelection = (selectedOption: tabs) => {
	if(selectedOption === 'destinations'){
		routeToDestinations();
	}
	if(selected.value === selectedOption){
		selected.value = null;
	}else{
		selected.value = selectedOption;
	}
};

const accountDropdownOpen = ref(false);
const handleAccount = () => {
	if(isNative){
		accountDropdownOpen.value = !accountDropdownOpen.value;
	}else{
		routeToDestinations();
	}
};

function openHXPWebsite(){
	window.open('https://www.hxp.org/');
}

function openFacebook() {
	window.open('https://www.facebook.com/HumanitarianExperience/');
}

function openInstagram() {
	window.open('https://www.instagram.com/hxp.humanitarianexperience/?hl=en');
}

function routeToSearch(){
	let url = "https://hxp.org/?swp_form%5Bform_id%5D=1&swps=";
	url += searchQuery.value;
	window.open(url);
}

function openLink(link:string){
	window.open(link);
}

function transformUppercase(word: string){
    return word.toLocaleUpperCase()
}


const searchQuery = ref("");
const results = ref<any[]>([]);
const loading = ref(false);
const error = ref('');

const performSearch = async () => {
	console.log("Performing search....",searchQuery.value);
	results.value = [];
	if (!searchQuery.value) {
		error.value = 'Please enter a search query.';
		return;
	}

	loading.value = true;
	error.value = "";

	let sQuery = encodeURIComponent(searchQuery.value);
	let queryUrl = `https://hxp.org/wp-json/swp_api/search?s=${sQuery}&engine=default`;

	try {
		const response = await fetch(queryUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});
		if (!response.ok) {
			throw new Error('Error fetching search results');
		}

		const data = await response.json();
		data.forEach((result:any)=>{
			if(result.title && result.link && result.type !== 'attachment') {
				const tmp = {
					title: result.title.rendered,
					link: result.link
				};
				results.value.push(tmp);
			}
		});
		//console.log("Results:",results.value);
	} catch (err) {
		error.value = 'Error fetching search results';
		console.error(err);
	} finally {
		loading.value = false;
	}

	//console.log("Results:",results.value, loading.value);
};

let timeout: ReturnType<typeof setTimeout> | null = null;
watch(()=> searchQuery.value, async (newVal, oldVal) =>{
	if(newVal !== oldVal && newVal.length >= 3){
		if(timeout) clearTimeout(timeout);
		timeout = setTimeout(async ()=>{
			loading.value = true;
			await performSearch();
			loading.value = false;
		},750);
		
	}

	if(newVal.length === 0){
		results.value = [];
		loading.value = false;
	}
});


const __returned__ = { props, tabsOptions, tabsNameMap, zohoLinks, linksBySections, selected, searchBarExpanded, hideContent, expandSearch, shrinkSearch, closeSearch, hovering, handleHover, handleLeaveHover, handleTabClick, mobileDropdownExpanded, handleSelection, accountDropdownOpen, handleAccount, openHXPWebsite, openFacebook, openInstagram, routeToSearch, openLink, transformUppercase, searchQuery, results, loading, error, performSearch, get timeout() { return timeout }, set timeout(v) { timeout = v }, computed, onMounted, ref, watch, get headerHeight() { return headerHeight }, get isMobile() { return isMobile }, get shrunkSearch() { return shrunkSearch }, get isNative() { return isNative }, get navbarDefaultWidth() { return navbarDefaultWidth }, get getZohoNavLinks() { return getZohoNavLinks }, get routeToDestinations() { return routeToDestinations }, get logOut() { return logOut } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})